<template>
  <v-container fluid>
    <v-row justify="start" class="about-page">
      <input-block class="about" :modules="top" title="О компании" />
      <input-block
        class="step"
        :modules="steps"
        title="Этапы"
        :options="{ tabs: true }"
      />
    </v-row>
  </v-container>
</template>

<script>
import InputBlock from "../InputBlock/InputBlock";

export default {
  name: "AboutPage",
  components: { InputBlock },
  data() {
    return {
      top: {
        about: {
          image: {
            type: "image",
            langs: ["all"],
            hint: "1439 × 400 px"
          },
          text: {
            type: "textHtml",
            langs: ["ru", "kk", "en"],
            toolbar: [["bold", "italic", "underline"], ["link"]],
            label: "",
            maxHeight: 300
          }
        }
      },
      steps: {
        about: {
          steps_title: {
            type: "string",
            langs: ["ru", "kk", "en"],
            label: "Заголовок",
            textarea: true
          },
          step1: {
            type: "string",
            langs: ["ru", "kk", "en"],
            label: "Шаг 1",
            textarea: true
          },
          step2: {
            type: "string",
            langs: ["ru", "kk", "en"],
            label: "Шаг 2",
            textarea: true
          },
          step3: {
            type: "string",
            langs: ["ru", "kk", "en"],
            label: "Шаг 3",
            textarea: true
          },
          step4: {
            type: "string",
            langs: ["ru", "kk", "en"],
            label: "Шаг 4",
            textarea: true
          }
        }
      }
    };
  }
};
</script>

<style lang="scss">
.about-page {
  gap: 24px;
  align-items: flex-start;

  .textCard {
    min-width: 400px;
    flex: 1;
    display: flex;
    flex-direction: column;
    .v-card__text {
      flex-grow: 1;
    }
  }
}
</style>
